import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";

export default class EditButton extends Component {
  render() {
    const { fluid, disabled, to, text } = this.props;
    return (
      <Button
        className="edit-button"
        icon
        as={Link}
        size="small"
        labelPosition="left"
        to={to}
        disabled={disabled}
        fluid={fluid}
      >
        <Icon name="plus" />
        <span style={{ marginLeft: "23px" }}>{text}</span>
      </Button>
    );
  }
}

EditButton.propTypes = {
  text: PropTypes.string,
  fluid: PropTypes.bool,
  disabled: PropTypes.bool,
  to: PropTypes.string.isRequired,
};

EditButton.defaultProps = {
  text: "Edit",
  fluid: false,
  disabled: false,
};
